// @core/api/endpoints/subscription/update_discount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DiscountResponse,
  UpdateDiscountRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update discount
 * Updates discount settings. Changes do not affect subscriptions that have already applied this discount.
 */
export async function UpdateDiscount(
  discount_id: string,
  data: UpdateDiscountRequest,
  options?: RequestOptions
): Promise<DiscountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/discounts/:discount_id`;
  requestPath = requestPath.replace(':discount_id', encodeURIComponent(discount_id));
  const requestOptions = options;
  return client.put<DiscountResponse>(requestPath, data, requestOptions);
}
